<template>
  <main class="l-main p-report-download">
    <TitleMain icon="download">
      <span class="title">レポートダウンロード</span>
      <span class="description">
        月間のサイト分析レポートをダウンロードいただけます。
      </span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <ReportSite :project="project" />
    </div>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import ButtonToProjects from '@/components/ButtonToProjects';
import ReportSite from '@/components/reportDownload/ReportSite';
import TitleMain from '@/components/TitleMain';

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Breadcrumb,
    ButtonToProjects,
    ReportSite,
    TitleMain
  }
};
</script>
